import React from 'react'

export default function BreadcrumbIndexEntry({breadcrumb,pickupBreadcrumbs}) {
    console.log("breadcrumbindexentry1:",breadcrumb);
    console.log("breadcrumbindexentry2:",breadcrumb.name);
    // console.log("breadcrumbindexentry3:",breadcrumb.type.name);
    // console.log("breadcrumbindexentry4:",breadcrumb.breadcrumb.type.name);
    function pickupEntryBreadcrumb(e){
        console.log("breadcrumb.key",breadcrumb.key);
        pickupBreadcrumbs(breadcrumb.key);
    }
    return (
        <>
        &#8594;
        <button onClick={pickupEntryBreadcrumb}> {breadcrumb.name} </button>
        </>
    )
}
